// extracted by mini-css-extract-plugin
export default {"pageBtn":"PaginationButtons_pageBtn__Kj8C0"};